(function() {
    'use strict';

    var StoricoModificheContatti = function(
        $q,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        messaggiFctr,
        storicoDinamicoService,
        invioCredenzialiService,
        $uibModalInstance,
        uiGridConstants
    ) {
        this.listaRichieste = [];
        this.loading = 0;
        this.invioCredenzialiService = invioCredenzialiService;

        this.init = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            storicoDinamicoService
                .openLista(invioCredenzialiService.datiMito.codiceUtente)
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res) || !res.data.result) {
                            return;
                        }
                        this.listaRichieste = [];
                        let risultati = res.data.result; // storicoDinamicoService.mock.result
                        risultati.forEach((richiesta) => {
                            richiesta = this.formattaTipo(richiesta);
                            this.listaRichieste.push(richiesta);
                        });
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        this.gridStorico = {
            enableSorting: true,
            enableHiding: false,
            enableColumnMenus: false,
            enableVerticalScrollbar: 0,
            enableHorizontalScrollbar: 0,
            paginationPageSize: 9,
            columnDefs: [
                { field: 'creazione', name: 'Data Operazione', cellFilter: "date:'dd/MM/yyyy HH:mm'" },                
                { field: 'canale', name: 'Canale' },
                { field: 'tipoDescrittivo', name: 'Tipo' },
                { field: 'vecchioValore', name: 'Valore Vecchio' },
                { field: 'nuovoValore', name: 'Valore Nuovo' },
                { field: 'operatore', name: 'Operatore' },
            ],
            data: 'storicoCtrl.listaRichieste'
        };

        this.formattaTipo = (elemento) => {
            switch (elemento.tipo) {
                case "EMAIL":
                    elemento.tipoDescrittivo = "Email";
                    break;
                case "ADD_PHONE":
                    elemento.tipoDescrittivo = "Aggiunto telefono";
                    break;
                case "DEL_PHONE":
                    elemento.tipoDescrittivo = "Rimosso telefono";
                    break;
                case "SET_PRIMARY":
                    elemento.tipoDescrittivo = "Impostato primario";
                    break;
                default:
                    elemento.tipoDescrittivo = "N.D.";
            }
            return elemento;
        };

        this.close = () => {
            $uibModalInstance.dismiss();
        };

        this.init();
    };

    StoricoModificheContatti.$inject = [
        '$q',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomStoricoModificheContattiService',
        'MitomInvioCredenzialiService',
        '$uibModalInstance',
        'uiGridConstants'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .controller('MitomStoricoModificheContattiController', StoricoModificheContatti);
})();